<template>
  <article class="entity">
    <h2 v-if="content.image" class="entity__title"><img class="entity__title--image" :src="content.image.url" :alt="content.image.alt"/></h2>
    <h2 v-else class="entity__title">{{ content.title }}</h2>

    <div class="rte">
      <component v-for="item in content.details" :is="item.component" :item="item"/>
    </div>

    <a v-if="content.url" class="entity__link" :href="content.url" target="_blank">voir le site <icon :id="'arrow'"/></a>

    <router-link to="/ecosysteme" tag="button" class="entity__close">&times;</router-link>
  </article>
</template>

<script>
export default {
  name: 'entity-details',
  props: {
    entity: String,
    details: Object
  },

  computed: {
    content() { return this.details[this.entity] }
  }
}
</script>



// WEBPACK FOOTER //
// EntityDetails.vue?e554215e